export default "__VITE_ASSET__DUeVTkXK__"